import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { checkIfPhoneIsValid, checkIfEmailIsValid } from 'utils/functions/formValidation';
import { fetchAddOrEditAdvertiserSubmission } from 'modules/advertisers/actions';
import AddAdvertiserComponent from 'modules/advertisers/components/AddAdvertiserComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const AddAdvertiserContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const { advertiserDetails } = useSelector(state => ({
    advertiserDetails: state.advertisers.advertiserDetails,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id: advertiserKey } = useParams();
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [formFieldsValues, setFormFieldsValues] = useState({
    name: (advertiserKey && advertiserDetails.name) || '',
    phone: (advertiserKey && advertiserDetails.phone) || '',
    email: (advertiserKey && advertiserDetails.email) || '',
  });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    name: true,
    phone: true,
    email: true,
  });
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const addOrEditAdvertiserSuccessCallback = () => {
    navigate('/advertisers');
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextInputFieldChange = (fieldName, fieldEvent) => {
    const { value } = fieldEvent.target;

    setFormFieldsValues(prevValue => {
      const fieldsObj = { ...prevValue };
      fieldsObj[fieldName] = value;

      return fieldsObj;
    });
  };

  const handleAddOrEditAdvertiserBtnClick = () => {
    let isPhoneValid = true;
    let isEmailValid = true;
    let isFormValid = true;

    if (!formFieldsValues.name || !formFieldsValues.phone || !formFieldsValues.email) {
      setFormFieldsValidation({
        name: !!formFieldsValues.name,
        phone: !!formFieldsValues.phone,
        email: !!formFieldsValues.email,
      });
      isFormValid = false;
    }

    if (checkIfPhoneIsValid(formFieldsValues.phone) === false) {
      isPhoneValid = false;
      isFormValid = false;
    }
    setFormFieldsValidation(prevState => ({
      ...prevState,
      phone: isPhoneValid,
    }));

    if (checkIfEmailIsValid(formFieldsValues.email) === false) {
      isEmailValid = false;
      isFormValid = false;
    }
    setFormFieldsValidation(prevState => ({
      ...prevState,
      email: isEmailValid,
    }));

    if (isFormValid === false) return;

    setFormFieldsValidation({
      name: true,
      phone: true,
      email: true,
    });

    const body = {
      data: {
        Name: formFieldsValues.name,
        Phone: formFieldsValues.phone,
        Email: formFieldsValues.email,
      },
      callbackActionSuccess: addOrEditAdvertiserSuccessCallback,
    };
    if (advertiserKey) body.advertiserKey = advertiserKey;

    dispatch(fetchAddOrEditAdvertiserSubmission(body));
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <AddAdvertiserComponent
      formFieldsValues={formFieldsValues}
      formFieldsValidation={formFieldsValidation}
      handleTextInputFieldChange={handleTextInputFieldChange}
      handleAddOrEditAdvertiserBtnClick={handleAddOrEditAdvertiserBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AddAdvertiserContainer.propTypes = {};

AddAdvertiserContainer.defaultProps = {};

export default AddAdvertiserContainer;
